import script from "./FormInputCopy.vue?vue&type=script&setup=true&lang=js"
export * from "./FormInputCopy.vue?vue&type=script&setup=true&lang=js"

import "./FormInputCopy.vue?vue&type=style&index=0&id=570d0c86&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-570d0c86"]])

export default __exports__